var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  _vm.cssClass,
  ("widget-" + _vm.variant + " widget-content"),
  {
    'card border-transparent': !_vm.inset,
    'soft-shadow': _vm.shadow,
    'transparent': _vm.transparent
  }
]},[_c('div',{class:{
    'card-body': !_vm.inset,
  }},[_vm._t("widget-header",[_c('widget-header',{attrs:{"config":_vm.config}})]),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("widget-footer",[_c('widget-footer',{attrs:{"config":_vm.config},on:{"refresh":function($event){return _vm.$emit('refresh')}}})])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }